import { render, staticRenderFns } from "./ContractFormDialog.vue?vue&type=template&id=0987885c&scoped=true"
import script from "./ContractFormDialog.vue?vue&type=script&lang=js"
export * from "./ContractFormDialog.vue?vue&type=script&lang=js"
import style0 from "./ContractFormDialog.vue?vue&type=style&index=0&id=0987885c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987885c",
  null
  
)

export default component.exports